var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06375 4.06554C5.06375 4.24317 5.00625 4.42079 4.88302 4.56102L1.98308 7.86112C1.74484 8.13223 1.35051 8.13223 1.11227 7.86112C0.874034 7.59001 0.874034 7.14127 1.11227 6.87016L3.57681 4.06554L1.11227 1.26093C0.874034 0.989816 0.874034 0.541078 1.11227 0.269965C1.35051 -0.00114729 1.74484 -0.00114731 1.98308 0.269965L4.88302 3.57006C5.00625 3.71029 5.06375 3.88792 5.06375 4.06554Z",
    fill: "#F6F6F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/RightIcon.e196d9350f0f409022c098c0e11bb3c6.svg";
export { ForwardRef as ReactComponent };